/**
 * Forms JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Forms
 */
class Forms {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.radioFields    = $( '.ginput_container_radio' );
        this.checkboxFields = $( '.ginput_container_checkbox' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // An even for the to fire after submit
        $( document ).on( 'gform_post_render', ( e ) => {

            // Focus on the error message and read it live
            this.focusToHeading( '.validation_error' );

            // Get all the fields to rearrange the error message to be read in correct order
            const allFields = $( '.gfield' );
            allFields.each( ( e, item ) => {

                // Get the error message and remove the original one
                const errorMessage = $( item ).children( '.validation_message' );
                $( item ).children( '.validation_message' ).remove();

                // Get the title and insert the error message after that
                const titleLabel = $( item ).children( '.gfield_label' );
                titleLabel.after( errorMessage );
            });

        });

        // Focus and read live the confirmation message
        $( document ).on( 'gform_confirmation_loaded', ( e ) => {
            this.focusToHeading( '.gform_confirmation_message' );
        });
    }

    /**
     * Modify a forms file uploads delete chosen images section
     */
    modifyUploadedFiles() {

        if ( typeof gform !== 'undefined' ) {
            gform.addFilter( 'gform_file_upload_markup', function(  html, file ) {

                // Get the strings to be used here
                const uploadedString = themeData.themeStrings.forms.uploaded_file;
                const deleteString = themeData.themeStrings.forms.remove_file;

                // Build the file name to be shown
                const fileName = '<span class="uploaded-file-name">' + uploadedString + ': ' + file.name + '</span>';

                // Build the delete button - add a span for screenreaders
                const deleteButton = '<button class="delete-uploaded-image" onclick="gformDeleteUploadedFile(1,27, this);" onkeypress="gformDeleteUploadedFile(1,27, this)"";> <img src="/app/themes/vaasa/assets/images/trash-alt.svg" alt="' + deleteString + '" class="delete-uploaded-image__icon" aria-hidden="true"> ' + deleteString + '<span class="sr-only">' + fileName + '</span></button>';

                // Modify the element to match what we want
                html = fileName + deleteButton;

                return html;
            });
        }
    }

    /**
     * Function to focus on either a success heading or an error heading
     */
    focusToHeading( headingToFocus ) {
        $( headingToFocus ).attr( 'tabindex', '-1' );
        $( headingToFocus ).focus();
        $( headingToFocus ).attr( 'aria-live', 'polite' );
        $( headingToFocus ).attr( 'role', 'alert' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.modifyUploadedFiles();
    }
}

// Export the class reference.
module.exports = Forms;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/forms.js